/**
 * Decode HTML entities in a string so special characters display correctly.
 * Use when displaying user- or API-supplied text (e.g. trip names) that may
 * be stored with entities like &#x27; (apostrophe).
 *
 * @param {string} str - Raw string that may contain HTML entities
 * @returns {string} Decoded string safe for display
 */
export function decodeHtmlEntities(str) {
  if (str == null || typeof str !== 'string') return str == null ? '' : str;
  return str
    .replace(/&apos;/gi, "'")
    .replace(/&#x27;/gi, "'")
    .replace(/&#39;/g, "'")
    .replace(/&quot;/gi, '"')
    .replace(/&#x22;/gi, '"')
    .replace(/&#34;/g, '"')
    .replace(/&amp;/gi, '&')
    .replace(/&#x26;/gi, '&')
    .replace(/&#38;/g, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&#x3C;/gi, '<')
    .replace(/&#60;/g, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&#x3E;/gi, '>')
    .replace(/&#62;/g, '>')
    .replace(/&#(\d+);/g, (_, code) => {
      const n = parseInt(code, 10);
      return n >= 0 && n <= 0x10ffff ? String.fromCodePoint(n) : _;
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, hex) => {
      const n = parseInt(hex, 16);
      return n >= 0 && n <= 0x10ffff ? String.fromCodePoint(n) : _;
    });
}
